import { Observable } from 'rxjs';
import { VideoSeriesModel } from '../../models';

export abstract class BaseVideoService {
  public videoType?: string;
  public abstract getVideoSeries(seriesName?: string): Observable<VideoSeriesModel[]>;
}
